<template>
  <md-card>
    <md-card-header data-background-color="secondary">
      <h4 class="title">Business Details</h4>
    </md-card-header>
    <md-card-content>
      <div class="md-layout">
        <card-group label="Business Name" class="md-size-33">
          {{ business.business_name }}
        </card-group>
        <card-group label="Trading Name" class="md-size-33">
          {{ business.trading_name }}
        </card-group>
        <card-group label="Business ABN/ACN" class="md-size-33">
          {{ business.abn }}
        </card-group>
        <card-group label="Business Phone Number" class="md-size-33">
          {{ business.phone_number }}
        </card-group>
        <card-group label="Business Email Address" class="md-size-33">
          {{ business.email }}
        </card-group>
        <card-group label="Business Type" class="md-size-33">
          {{ business.business_type }}
        </card-group>
        <card-group label="Contact Name">
          {{ business.contact_name }}
        </card-group>
      </div>
      <div class="md-layout mt-3">
        <card-group label="Business Address" class="md-size-100">
          {{ business.business_address }},
          {{ business.business_address_suburb }},
          {{ business.business_address_state }}
          {{ business.business_address_postcode }}
        </card-group>
        <card-group label="Postal Address" class="md-size-100">
          {{ business.postal_address }}, {{ business.postal_address_suburb }},
          {{ business.postal_address_state }}
          {{ business.postal_address_postcode }}
        </card-group>
      </div>
      <div class="md-layout mt-3">
        <card-group label="Vehicles">
          {{ business.vehicles.map(v => v["number_plate"]).join(", ") }}
        </card-group>
      </div>
    </md-card-content>
  </md-card>
</template>

<script>
import CardGroup from "@/components/Cards/CardGroup";
export default {
  name: "BusinessSummaryCard",
  components: { CardGroup },
  computed: {
    business() {
      return this.$store.getters.authUser.business;
    }
  }
};
</script>

<style scoped></style>
